export const edgeEnd = {
    "STANDARD": "Стандарт",
    "CHAMFER45": "Срез под 45°",
}